// extracted by mini-css-extract-plugin
export default {"shell":"authLayout_shell__kpVa1","main":"authLayout_main__hxTzm","fallback":"authLayout_fallback__t3xeu"};